// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"ef135dbb","11":"35d3ca3c","163":"a74c3136","213":"4644d31e","239":"79cb9acb","453":"f1b8e904","455":"eadf7857","642":"8982f472","821":"2ae95606"}[chunkId] + ".chunk.js";
};